import { useIntl } from "react-intl";
import {
  SERVICE_DEAL_TYPE,
  TGetServicesCollectionItem,
} from "../../api/service/service.types";

export default function useStandarizedServiceTitle(
  service: TGetServicesCollectionItem
) {
  const { formatMessage } = useIntl();

  let title = "";
  if (service.Tipo_de_Trato === SERVICE_DEAL_TYPE.HOURLY_PROFESSIONAL) {
    title += formatMessage({
      id: "ServiceTitle.Hourly",
      defaultMessage: "Profesional por horas ",
    });
  } else if (service.Tipo_de_Trato === SERVICE_DEAL_TYPE.CUIDEO_ASIST) {
    title += formatMessage({
      id: "ServiceTitle.Cuideo Assist",
      defaultMessage: "Cuideo Assist ",
    });
  } else {
    title += formatMessage({
      id: "ServiceTitle.Caretaker",
      defaultMessage: "Cuidador/a ",
    });
    if (service.Tipo_de_Trato === SERVICE_DEAL_TYPE.INTERNAL_DURING_WEEK) {
      title += formatMessage({
        id: "ServiceTitle.InternalDuringWeek",
        defaultMessage: "Interno/a entre semana ",
      });
    } else if (
      service.Tipo_de_Trato === SERVICE_DEAL_TYPE.INTERNAL_DURING_WEEKEND
    ) {
      title += formatMessage({
        id: "ServiceTitle.InternalDuringWeekend",
        defaultMessage: "Interno/a fin de semana ",
      });
    } else {
      title += formatMessage({
        id: "ServiceTitle.External",
        defaultMessage: "Externo/a ",
      });
    }
  }

  if (service.Ciudad || service.Provincia) {
    title += "| ";

    if (service.Ciudad === service.Provincia) {
      title += service.Ciudad;
    } else if (service.Ciudad && !service.Provincia) {
      title += service.Ciudad;
    } else if (!service.Ciudad && service.Provincia) {
      title += `(${service.Provincia})`;
    } else {
      title += `${service.Ciudad} (${service.Provincia})`;
    }
  }

  return title.trim();
}
